import { getApps, getApp, initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth, GoogleAuthProvider } from 'firebase/auth'
import { PARAMETROS_GOOGLE } from './dominios'

// OJO rendimiento: aquí SOLO app + auth (lo que necesita el arranque/login).
// Firestore vive en lib/db.ts para que su SDK no entre al chunk inicial (Lighthouse).
// getApps() guard: idempotente ante HMR/dobles imports (initializeApp dos veces
// lanza 'duplicate-app' y rompía auth → /api/team 401 → sin roster de menciones).
const app = getApps().length
  ? getApp()
  : initializeApp({
      apiKey: import.meta.env.VITE_FB_API_KEY,
      authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN,
      projectId: import.meta.env.VITE_FB_PROJECT_ID,
      appId: import.meta.env.VITE_FB_APP_ID,
      messagingSenderId: import.meta.env.VITE_FB_MESSAGING_SENDER_ID,
      storageBucket: import.meta.env.VITE_FB_STORAGE_BUCKET,
    })

export const auth = getAuth(app)

export const googleProvider = new GoogleAuthProvider()
// hd es solo pista de UX; la seguridad real vive en blocking functions + API (auth-permisos.md).
// Con dos dominios (D-26) va hd=* (solo cuentas de Workspace): ver lib/dominios.ts.
googleProvider.setCustomParameters({ ...PARAMETROS_GOOGLE })

if (import.meta.env.VITE_USE_EMULATORS === '1') {
  // Puerto configurable: cuando otro repo de la familia tiene su emulador en el 9099
  // (pasa en esta misma máquina), camp se levanta en otro puerto sin tocar código.
  const puertoAuth = import.meta.env.VITE_AUTH_EMULATOR_PORT || '9099'
  connectAuthEmulator(auth, `http://localhost:${puertoAuth}`, { disableWarnings: true })
  // Helper SOLO-dev para QA/E2E: entrar sin popup contra el emulador de Auth.
  // window.__campLogin('correo@beemexico.com', 'Nombre')
  void import('firebase/auth').then(({ signInWithCredential, GoogleAuthProvider: GP }) => {
    ;(window as unknown as Record<string, unknown>).__campLogin = (email: string, name: string) =>
      signInWithCredential(
        auth,
        GP.credential(
          JSON.stringify({ sub: email.split('@')[0], email, email_verified: true, name }),
        ),
      )
  })
}

/**
 * Entrada de un clic para la DEMO LOCAL. Solo existe con emuladores y cuando
 * demo/arrancar.sh le pasa quién conduce la demo. POR QUÉ: el emulador de Auth no
 * guarda las sesiones al reiniciarse, así que cada arranque saca a todos; volver a
 * entrar tecleando en la consola frente al cliente es justo lo que no debe pasar.
 */
export const demoLocal: { email: string; nombre: string } | null =
  import.meta.env.VITE_USE_EMULATORS === '1' &&
  import.meta.env.VITE_DEMO_LOGIN_EMAIL &&
  import.meta.env.VITE_DEMO_LOGIN_NAME
    ? { email: String(import.meta.env.VITE_DEMO_LOGIN_EMAIL), nombre: String(import.meta.env.VITE_DEMO_LOGIN_NAME) }
    : null

export async function entrarDemoLocal(): Promise<void> {
  if (!demoLocal) throw new Error('Solo en la demo local')
  const { signInWithCredential, GoogleAuthProvider: GP } = await import('firebase/auth')
  const { email, nombre } = demoLocal
  await signInWithCredential(
    auth,
    GP.credential(JSON.stringify({ sub: email.split('@')[0], email, email_verified: true, name: nombre })),
  )
}

export { app as firebaseApp }
